import { memo } from "react";
import { FieldTypeEditorProps } from "../types";

export const SourceOfActiveFieldTypeSpecificProps = memo(
  (_props: FieldTypeEditorProps) => null,
);
